/**Custom implementation of Array.groupBy function.
 * For some reason this isn't available natively.
 */
export default function <T, Key extends string | number | symbol>(
  array: T[],
  keyFn: (item: T) => Key | undefined,
  noGroupKey?: Key,
): Record<Key, T[]> {
  return array.reduce(
    (result, item) => {
      let key = keyFn(item)
      if (key === undefined) {
        key = noGroupKey
      }
      if (key === undefined) {
        throw new Error(
          "No key matched in groupBy. Provide a group with the noGroupKey to catch any records that don't match a group by key from the keyFn",
        )
      }
      ;(result[key] ??= []).push(item)
      return result
    },
    {} as Record<Key, T[]>,
  )
}
